module.exports = __webpack_public_path__ + "media/notice1.9bbd1832.mp3";